import Comfortable from 'comfortable-javascript';

export const comfortable = Comfortable.api('blogfs', 'BnPokJkuuJABYkunOTWrtQESYjSzuHjz');